import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="text-center mt-5">
      <h1 className="text-danger">404 - Page Not Found</h1>
      <p className="text-muted">Oops! The page you are looking for does not exist.</p>
      <button className="btn btn-primary mt-3" onClick={() => navigate("/")}>
        Go to Home
      </button>
    </div>
  );
}
